import { FC, useMemo } from 'react';
import BusinessButton from '../business-button/business-button';
import styles from './not-found.module.scss';
import { Locale, localifyLink } from '@/helpers/LangHelper';
import BusinessHubLayout from '../layouts/business-hub-layout';
import Head from 'next/head';
import MetaBlock from '../meta-block/MetaBlock';
import B2BLayout from '../layouts/b2b-layout';
import { COLORS } from '../business-button/business-button.constants';
import Image from 'next/image';

interface Props {
    locale: Locale;
}

export const NotFound: FC<Props> = ({ locale }) => {
    const content = useMemo(() => {
        return (
            <>
                <MetaBlock title="Not found" description="" />
                <Head>
                    <meta name="robots" content="noindex" />
                </Head>
                <div className={styles.container}>
                    <div className={styles.background}>
                        <div className={styles.imageDesktop}>
                            <Image
                                src={
                                    locale === Locale.USA
                                        ? 'https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F3f0f5343515a40c8882e63c512f67c17'
                                        : 'https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F004065bd99cd421bbdc17dc01367d887'
                                }
                                alt=""
                                loading={'lazy'}
                                fill
                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                                loader={({ src, width, quality }) => {
                                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                                }}
                            />
                        </div>
                    </div>
                    <div className={styles.overlay}>
                        <div className={styles.title}>Page not found.</div>
                        <div className={styles.description}>Let’s get back you back on the right path.</div>
                        <div className={styles.cta}>
                            <BusinessButton
                                buttonText="Discover Afterpay for Business"
                                autoMargin={false}
                                link={localifyLink(`/${locale}/business`, locale)}
                                color={locale === Locale.USA ? COLORS.WHITE : COLORS.MINT}
                            />
                        </div>
                        <div className={styles.imageMobile}>
                            <Image
                                src={
                                    locale === Locale.USA
                                        ? 'https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F4c6ab5b8055a4d488821c76d5aa14efd'
                                        : 'https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2Fe38c87e5cfcf4a908ff72b4419463308'
                                }
                                alt=""
                                loading={'lazy'}
                                fill
                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                                loader={({ src, width, quality }) => {
                                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }, [locale]);

    if (locale === Locale.USA) {
        return (
            <B2BLayout page={{ data: { hideFooter: true } }} model="business-hub">
                {content}
            </B2BLayout>
        );
    }

    return <BusinessHubLayout page={{ data: { hideFooter: true } }}>{content}</BusinessHubLayout>;
};
